import React from "react"
import types from "prop-types"
import clsx from "clsx"

const ImpersonationBadge = ({ className = "", text = "impersonator" }) => (
  <span className={clsx("impersonation-badge", className)}>
    {text}
  </span>
)

ImpersonationBadge.propTypes = {
  className: types.string,
  text: types.string,
}

export default ImpersonationBadge
